export default "/JMMMU/japanese_history.a0df29f1-b589db.jpg";